import React, { createContext, useContext } from "react";
import { useItemDetails } from "./useItemDetails";

// Create context
const ItemDetailsContext = createContext(null);

/**
 * Provider component that wraps item details modal and provides
 * all state and handlers to child components via context
 */
export const ItemDetailsProvider = ({
    children,
    isOpen,
    itemData,
    itemInfo,
    itemType,
    depth,
    handleClose,
    updateNameHandler,
    setItemData,
    on_delete,
    fetchItemDetails,
    href,
}) => {
    const itemDetailsState = useItemDetails({
        isOpen,
        itemData,
        itemInfo,
        itemType,
        depth,
        handleClose,
        updateNameHandler,
        setItemData,
        on_delete,
        fetchItemDetails,
        href,
    });

    // Include original props that child components might need
    const contextValue = {
        ...itemDetailsState,
        // Original props
        isOpen,
        itemData,
        itemInfo,
        itemType,
        depth,
        handleClose,
        href,
    };

    return (
        <ItemDetailsContext.Provider value={contextValue}>
            {children}
        </ItemDetailsContext.Provider>
    );
};

/**
 * Custom hook to access item details context
 * Throws error if used outside of provider
 */
export const useItemDetailsContext = () => {
    const context = useContext(ItemDetailsContext);
    if (!context) {
        throw new Error("useItemDetailsContext must be used within ItemDetailsProvider");
    }
    return context;
};
